<template>
  <div>
    <ReloadPromt></ReloadPromt>
    <b-navbar toggleable="md" type="dark" fixed="top">

      <b-navbar-brand @click="showDefault"><img src="/static/images/teams.png" class="ws-logo img-fluid"></b-navbar-brand>

      <b-navbar-toggle target="nav_collapse"></b-navbar-toggle>
<b-collapse is-nav id="nav_collapse">

        <b-navbar-nav>
          <b-nav-item to="/tasks">MY TASKS
            <div class="underline"></div>
          </b-nav-item>
          <b-nav-item to="/my-inbox" @click="myInboxTotal()">MY INBOX <b-badge v-if="totalUserMessages !== 0" variant="light" pill> {{ totalUserMessages }} </b-badge>
            <div class="underline"></div>
          </b-nav-item>
          <b-nav-item to="/boards">MY BOARDS
            <div class="underline"></div>
          </b-nav-item>
          <b-nav-item v-b-modal.newBoard href="#" class="board-btn">CREATE BOARD</b-nav-item>
        </b-navbar-nav>

        <!-- Right aligned nav items -->
        <b-navbar-nav class="ml-auto">
          <b-nav-item to="/search">Search</b-nav-item>
          <Notifications/>
          <b-nav-item-dropdown right>
            <!-- Using button-content slot -->
            <template slot="button-content">
              <!-- Temporary nav-user-logo -->
              <img class="nav-user-logo" :src="currentUser.avatar">Menu
            </template>
            <b-dropdown-item v-if="(currentUser.roles.includes('admin'))" to="/admin" tag="li">Admin</b-dropdown-item>
            <b-dropdown-item to="/preferences">Preferences</b-dropdown-item>
            <b-dropdown-item to="/notification_settings">Notification Settings</b-dropdown-item>
            <b-dropdown-item v-b-modal.profile href="#">Profile</b-dropdown-item>
            <b-dropdown-item to="/customers">Customers</b-dropdown-item>
            <b-dropdown-item href="https://drive.google.com/drive/folders/1nUsm1epvcJFRQ661RYP3iINlfzA7ff5j?usp=sharing" target="_blank">Documents</b-dropdown-item>
            <b-dropdown-item to="/logout">Sign Out</b-dropdown-item>
          </b-nav-item-dropdown>
        </b-navbar-nav>

      </b-collapse>
    </b-navbar>
    <!--Used to clear Nav height, instead of padding-top every article component-->
    <div id="mobile-spacer" style="height: 63px;"></div>
    <div id="navdrawer-container" :class="open ? 'nav-open' : 'nav-closed'">
      <transition name="left-nav">
        <div id="vue-navdrawer" v-show="open" class="hidden-md-down">
          <slot name="drawer-content">
          <b-nav class="teamsNav" v-if="inboxPath">
            <b-form-group>
              <b-form-radio-group id="nav-toggle"
                      buttons
                      v-model="mailboxNav"
                      :options="options"
                      name="radiosBtnDefault" />
            </b-form-group>
          </b-nav>
            <NavMailbox v-if="mailboxNav && !adminNav" :subfolder="subfolder" />
            <NavTeams
            v-show="!mailboxNav && !adminNav && !searchNav"
            :currentUser="currentUser" />
            <NavAdmin v-if="adminNav" />
            <NavSearch v-if="searchNav" />
          </slot>
         </div>
      </transition>
      <div id="vue-navcontent">
        <slot name="main-content">
          <router-view/>
        </slot>
      </div>
    <a id="toggle-btn" @click="toggleNavDrawer" :class="open ? 'toggle-right' : 'toggle-left'">
      <fa icon="chevron-left" v-if="open" style="margin-left: -4px"/>
      <fa icon="chevron-right" v-else style="margin-left: 2px"/>
    </a>
    </div>
    <TaskForm :task="taskObject"></TaskForm>
    <TicketForm :ticket="ticketObject"></TicketForm>
    <NewMessageModal :mailbox="mailbox" :message="message"></NewMessageModal>
    <NewBoard/>
    <Profile/>
    <SearchResultsModal/>
    <TaskActions v-if="selectedTasks.length > 0" :selectedTasks="selectedTasks" :ticket="parentTicketObject"/>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import NewBoard from './NewBoard'
import NewMessageModal from './NewMessageModal'
import NavTeams from './NavTeams'
import Profile from './Profile'
import TaskActions from './TaskActions'
import TaskForm from './TaskForm'
import TicketForm from './TicketForm'
import Notifications from './Notifications'
import SearchResultsModal from './SearchResultsModal'
import NavMailbox from './NavMailbox'
import NavAdmin from './NavAdmin'
import NavSearch from './NavSearch'
import ReloadPromt from './ReloadPromt'
import cable from '@/action_cable'
export default {
  name: 'Navbar',
  components: {
    NewBoard,
    NewMessageModal,
    NavTeams,
    Profile,
    TaskActions,
    TaskForm,
    TicketForm,
    Notifications,
    SearchResultsModal,
    NavMailbox,
    NavAdmin,
    NavSearch,
    ReloadPromt
  },
  data: function () {
    return {
      subfolder: null,
      open: true,
      taskObject: {},
      totalUserMessages: 0,
      ticketObject: {},
      mailbox: '',
      usersUpdateInterval: null,
      myInboxInterval: null,
      clientsInterval: null,
      mailboxNav: false,
      message: {},
      connection: null,
      options: [
        { text: 'Mailboxes', value: false },
        { text: 'Inbox', value: true }
      ],
      selectedTasks: [],
      parentTicketObject: {}
    }
  },
  mounted () {
    var vm = this
    this.connection = cable.subscriptions.create({channel: 'GeneralChannel'}, {
      connected: function () {
      },
      received: function (response) {
        if (response.message === 'RELOAD_APP') {
          this.$root.$emit('bv::show::modal', 'reload-promt-modal')
        } else if (response.message === 'RELOAD_USERS') {
          vm.$store.dispatch('loadUsers')
        } else if (response.message === 'RELOAD_CLIENTS') {
          this.$store.dispatch('loadClients')
        } else if (response.message === 'NEW_NOTIFICATIONS') {
          this.$store.dispatch('loadNotifications')
        }
      }.bind(this)
    })
    if (window.innerWidth < 768) {
      this.toggleNavDrawer()
      document.querySelector('#vue-navcontent').addEventListener('click', this.navDrawerListener)
    }
    vm.$store.dispatch('loadTags')
    vm.$store.dispatch('loadMailboxes')
    this.myInboxTotal()
    this.$root.$on('taskEdit', (task) => {
      this.taskObject = task
      this.$root.$emit('bv::show::modal', 'taskForm')
    })

    this.$root.$on('ticketEdit', (ticket) => {
      this.ticketObject = ticket
      this.$root.$emit('bv::show::modal', 'ticketForm')
    })

    this.$root.$on('ticketClone', (ticket) => {
      this.ticketObject = ticket
      this.$root.$emit('bv::show::modal', 'ticketForm')
    })

    this.$root.$on('composeMessage', (mailbox) => {
      this.mailbox = mailbox
      this.$root.$emit('bv::show::modal', 'newMessage')
    })

    this.myInboxInterval = setInterval(function () {
      vm.myInboxTotal()
    }, 60000)
    vm.$store.dispatch('loadClients')
    document.addEventListener('visibilitychange', this.userIntervals)
    this.$root.$on('toggleTeamsNav', this.toggleTeamsNav)
    this.showMailboxNav()
    this.$root.$on('taskActions', (data) => {
      this.selectedTasks = data.tasks
      this.parentTicketObject = data.ticket
      this.$root.$emit('bv::show::modal', 'taskActions')
    })
  },
  computed: {
    ...mapGetters({ currentUser: 'currentUser' }),
    adminNav () {
      if (this.$route.path.includes('admin')) {
        return true
      } else {
        return false
      }
    },
    inboxPath () {
      if (this.$route.name === 'Inbox' || this.$route.name === 'Message') {
        return true
      } else {
        return false
      }
    },
    searchNav () {
      if (this.$route.name === 'Search') {
        return true
      } else {
        return false
      }
    }
  },

  methods: {

    showMailboxNav () {
      if (this.$route.name === 'Inbox' || this.$route.name === 'InboxSubfolder' || this.$route.name === 'Message') {
        this.mailboxNav = true
        if (this.$route.name === 'InboxSubfolder') {
          this.subfolder = this.$route.params.subfolder_id
        }
        this.showTeamsNav = false
      } else if (!this.$route.path.includes('admin')) {
        this.mailboxNav = false
        this.showTeamsNav = true
      }
    },
    toggleNavDrawer () {
      this.open = !this.open
    },
    navDrawerListener () {
      if (this.open) {
        this.toggleNavDrawer()
      }
    },
    showDefault () {
      if (this.currentUser) {
        if (this.currentUser.defaultMailboxId) {
          var id = this.currentUser.defaultMailboxId
          this.$router.push('/inboxes/' + id)
        } else {
          this.$router.push('/boards')
        }
      }
      this.showMailboxNav()
    },
    addNotifications () {
      var ntf = document.querySelector('.notification')
      var count = Number(ntf.getAttribute('data-count')) || 0
      ntf.setAttribute('data-count', count + 1)
      ntf.classList.remove('notify')
      setTimeout(function () { ntf.classList.add('notify') }, 0.1)
      if (count === 0) {
        ntf.classList.add('show-count')
      }
    },
    myInboxTotal () {
      var vm = this
      this.$http
        .get('/current_user')
        .then(function (response) {
          vm.totalUserMessages = response.data.totalUserMessages
        })
        .catch(e => {
          console.log(e)
        })
    },
    userIntervals () {
      var vm = this
      if (document.hidden === true) {
        clearInterval(this.usersUpdateInterval)
        clearInterval(this.myInboxInterval)
      } else {
        vm.myInboxTotal()
        this.myInboxInterval = setInterval(function () {
          vm.myInboxTotal()
        }, 60000)
      }
    }
  },
  watch: {
    $route (to, from) {
      this.showMailboxNav()
    }
  },

  beforeDestroy () {
    document.removeEventListener('visibilitychange', this.userIntervals)
    document.removeEventListener('click', this.navDrawerListener)
    clearInterval(this.usersUpdateInterval)
    clearInterval(this.myInboxInterval)
    this.connection.unsubscribe()
  }
}

</script>

<style scoped>
#toggle-btn {
  position: absolute;
  bottom: 15px;
  left: 15px;
  z-index: 9999999999;
  border-radius: 100%;
  height: 50px;
  width: 50px;
  border: 5px solid rgba(255, 255, 255, 0.5);
  background: #57b2cd;
  color: rgba(255, 255, 255, 0.5);
  font-size: 30px;
  font-weight: 600;
  text-align: center;
  -webkit-transition: all 0.5s ease;
  -moz-transition: all 0.5s ease;
  -o-transition: all 0.5s ease;
  transition: all .5s ease;
}
#toggle-btn.toggle-right {
  left: 160px;
}
#toggle-btn.toggle-left {
  box-shadow: 2px 10px 30px rgba(0,0,0,.3);
}
#toggle-btn .svg-inline--fa {
  vertical-align: -.05em;
  cursor: pointer;
}
.ws-logo {
  cursor: pointer;
  padding-right: 15px;
  max-height: 30px;
}
a a.dropdown-item:hover {
  text-decoration: none;
}
.navbar {
  background: #434343;
}
.navbar-brand {
  width: 214px;
  margin-right: 0px;
}
@media (min-width: 768px) {
  .navbar-brand {
    border-right: 2px solid #ada6a64a;
  }
  .navbar-nav {
    margin-left: 5px;
  }
}
.board-btn a.nav-link {
  background: #57B2CD;
  border-radius: 20px;
  padding: 3px 20px;
  margin-top: 8px;
  font-size: 12px;
  font-weight: bold;
}
#vue-navdrawer {
  position: relative;
  height: 100%;
  background-color: #57B2CD;
  color: white;
  float: left;
  width: 230px;
  z-index: 9999;
  overflow-y: auto;
  overflow-x: hidden;
}
#vue-navcontent {
  position: relative;
  width: 100%;
  height: 100%;
  overflow-y: auto;
  overflow-x: hidden;
}
#navdrawer-container {
  position: fixed;
  width: 100%;
  height: calc(100% - 63px);
}
.nav-team-container {
  overflow-y: auto;
  overflow-x: hidden;
}
.nav-open #vue-navcontent {
  margin-left: 230px;
  width: calc(100% - 230px);
  transition: transform .3s ease-in-out, margin .3s ease-in-out;
}
.left-nav-enter,
.left-nav-leave-to {
  transform: translateX(-100%);
  -webkit-transform: translateX(-100%);
}
.nav-closed #vue-navcontent,
.left-nav-enter-active,
.left-nav-leave-active {
  transition: transform .3s ease-in-out, margin .3s ease-in-out;
}
.nav-user-logo {
  border-radius: 25px;
  height: 32px;
  margin-right: 5px;
}
.nav-alerts {
  line-height: 32px;
}

/* Notifications */

.notification {
  display: inline-block;
  position: relative;
  font-size: 1.3em;
}

.notification::before,
.notification::after {
  color: #fff;
  opacity: .5;
}
.notification:hover::before,
.notification:hover::after {
  opacity: 1;
}

.notification::before {
  display: block;
  content: "\e01d";
  font-family: "Icons";
  transform-origin: top center;
}

.notification::after {
  font-family: Arial;
  font-size: 0.7em;
  font-weight: 700;
  position: absolute;
  top: -15px;
  right: -25px;
  padding: 5px 8px;
  line-height: 100%;
  border: 2px #fff solid;
  border-radius: 60px;
  background: #57B2CD;
  opacity: 0;
  content: attr(data-count);
  opacity: 0;
  -webkit-transform: scale(0.5);
  transform: scale(0.5);
  transition: transform, opacity;
  transition-duration: 0.3s;
  transition-timing-function: ease-out;
}

.notification.notify::before {
  -webkit-animation: ring 1.5s ease;
  animation: ring 1.5s ease;
}

.notification.show-count::after {
  -webkit-transform: scale(1);
  transform: scale(1);
  opacity: 1;
}

@-webkit-keyframes ring {
  0% {
    -webkit-transform: rotate(35deg);
  }
  12.5% {
    -webkit-transform: rotate(-30deg);
  }
  25% {
    -webkit-transform: rotate(25deg);
  }
  37.5% {
    -webkit-transform: rotate(-20deg);
  }
  50% {
    -webkit-transform: rotate(15deg);
  }
  62.5% {
    -webkit-transform: rotate(-10deg);
  }
  75% {
    -webkit-transform: rotate(5deg);
  }
  100% {
    -webkit-transform: rotate(0deg);
  }
}

@keyframes ring {
  0% {
    -webkit-transform: rotate(35deg);
    transform: rotate(35deg);
  }
  12.5% {
    -webkit-transform: rotate(-30deg);
    transform: rotate(-30deg);
  }
  25% {
    -webkit-transform: rotate(25deg);
    transform: rotate(25deg);
  }
  37.5% {
    -webkit-transform: rotate(-20deg);
    transform: rotate(-20deg);
    }
  50% {
    -webkit-transform: rotate(15deg);
    transform: rotate(15deg);
  }
  62.5% {
    -webkit-transform: rotate(-10deg);
    transform: rotate(-10deg);
  }
  75% {
    -webkit-transform: rotate(5deg);
    transform: rotate(5deg);
  }
  100% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
}
.teamsNav a {
  color: #fff;
  font-size: 10pt;
}
.teamsNav, .teamsNav .form-group, #nav-toggle {
   width: 100%;
}
.teamsNav .b-form-group.form-group {
  margin-bottom: 0px !important;
}
@media (max-width: 767px) {
  #mobile-spacer {
    height: 58px !important;
  }
  .nav-open #vue-navcontent {
    margin-left: 0px;
    width: 100vw;
  }
  #vue-navdrawer {
    position: fixed;
  }
}
</style>

<style>
.modal-content {
    margin-top: 63px;
}
.ql-container {
  height: calc(100% - 62px)!important; /* 100% - height of 'ql-toolbar' */
}
#newMessage___BV_modal_body_ > form > div.quill-editor > div.ql-container.ql-snow {
  height: calc(100% - 85px)!important; /* 100% - height of 'ql-toolbar' */
}
#nav-toggle .btn {
  width: 50%;
  border-radius: unset;
  box-shadow: unset !important;
}
@media (max-width: 768px) {
  .nav-team:last-of-type {
    padding-bottom: 59px;
  }
}
@media (min-width: 768px) {
.navbar-nav li:hover .underline {
    background-color: #58b2cd;
    width: 100%;
  }
}
@media (min-width: 768px) {
.navbar-nav li .underline {
    height: 3px;
    background-color: transparent;
    width: 0%;
    -webkit-transition: width 0.3s, background-color 0.5s;
    transition: width 0.3s, background-color 0.5s;
    margin: 0 auto;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Navbar.vue